export const COMBINED_MODE = "combined";
export const SEPARATED_MODE = "separated";
export const MAIN_PANEL = "main";
export const ADMIN_PANEL = "admin";
